import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input} from '@progress/kendo-react-inputs';
import {DropDownList, MultiSelect} from '@progress/kendo-react-dropdowns';
import {DateTimePicker} from'@progress/kendo-react-dateinputs'
import { connect } from 'react-redux';
import { getColors, getSizes, getProductTypes} from '../../../../../Redux/Actions/CommonActions';
import './../ManageEvents/Events.scss';
import ReactFileReader from 'react-file-reader';
import { Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'
import './ManageProducts.scss';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class ProductForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			productInEdit: this.props.dataItem || null,			
            value: [],
            selectedProductType: null,
            colorList: this.props.dataItem.colors || [],
			sizeList: this.props.dataItem.sizes || [],
            imageList:this.props.dataItem.image || [],
            file: this.props.dataItem.ImageURL || null,
            originalTitle: this.props.dataItem.Title || '',
			titleMessage: '',
			discountMessage: '',
        };
      console.log(this.props, "State Colors");
    };

	componentDidMount() {		
		
	}

	handleSubmit = (event) => {
		event.preventDefault();
		const edited = this.state.productInEdit;
        console.log("this.state.file", this.state.file);
        if (edited.ProductId > 0) {
            var colors = [];
            var sizes = [];
            for (var i = 0; i < this.state.productInEdit.colors.length; i++) {
                var c = {
                    ProductColorOptionId: this.state.productInEdit.colors[i].colorOptionId,
                    Description: this.state.productInEdit.colors[i].description
                }
                colors.push(c);
            }

            for (var i = 0; i < this.state.productInEdit.sizes.length; i++) {
                var s = {
                    ProductSizeOptionId: this.state.productInEdit.sizes[i].sizeOptionId,
                    Description: this.state.productInEdit.sizes[i].description
                }
                sizes.push(s);
            }
            var model = {
                ProductId: Number(this.state.productInEdit.ProductId),
                Title: this.state.productInEdit.Title,
                ProductDescription: this.state.productInEdit.Description,
                ProductTypeId: Number(this.state.productInEdit.ProductTypeId),
                Price: Number(this.state.productInEdit.PriceDollars),
				Discount: this.state.productInEdit.DiscountDollars ? Number(this.state.productInEdit.DiscountDollars) : null,
                MemberDiscount: Number(this.state.productInEdit.MemberDiscountDollars),
                IsMemberOnly: this.state.productInEdit.IsMemberOnly,
                IsPublished: this.state.productInEdit.IsPublished,
                IsActive: this.state.productInEdit.IsActive,
                IsAddOn: this.state.productInEdit.IsAddOn,
                Colors: colors,
                Sizes: sizes,
                Image: this.state.productInEdit.Image
			};
			console.log(model);

			if (Number(this.state.productInEdit.DiscountDollars) >= Number(this.state.productInEdit.PriceDollars)) {

				this.setState({
					discountMessage: 'Discounted price must be less than the original price.'
				});

			} else {

				this.props.save({
					...model
				});
				this.props.cancel();
            }
        } else {
			axios.get(`${ROOT_API_URL}/ManageProducts/IsDuplicateTitle?title=${this.state.productInEdit.Title}`, { headers: auth.authHeader() })
                .then((response) => {
                    var colors = [];
					var sizes = [];
					if(this.state.productInEdit.colors) {
						for (var i = 0; i < this.state.productInEdit.colors.length; i++) {
							var c = {
								ProductColorOptionId: this.state.productInEdit.colors[i].colorOptionId,
								Description: this.state.productInEdit.colors[i].description
							}
							colors.push(c);
						}
					}
					if(this.state.productInEdit.sizes) {
						for (var i = 0; i < this.state.productInEdit.sizes.length; i++) {
							var s = {
								ProductSizeOptionId: this.state.productInEdit.sizes[i].sizeOptionId,
								Description: this.state.productInEdit.sizes[i].description
							}
							sizes.push(s);
						}
					}

                    var model = {
                        ProductId: Number(0),
                        Title: this.state.productInEdit.Title,
                        ProductDescription: this.state.productInEdit.Description,
                        ProductTypeId: Number(this.state.selectedProductType.id),
                        Price: Number(this.state.productInEdit.PriceDollars),
						Discount: this.state.productInEdit.DiscountDollars ? Number(this.state.productInEdit.DiscountDollars) : null,
                        MemberDiscount: Number(this.state.productInEdit.MemberDiscountDollars),
                        IsMemberOnly: this.state.productInEdit.IsMemberOnly,
                        IsPublished: this.state.productInEdit.IsPublished,
                        IsActive: this.state.productInEdit.IsActive,
                        IsAddOn: this.state.productInEdit.IsAddOn,
                        Colors: colors,
                        Sizes: sizes,
                        Image: this.state.productInEdit.Image
					};
					if (this.state.originalTitle !== this.state.productInEdit.Title) {
						this.setState({
							titleMessage: response.data.message
						});

					}

					if (Number(this.state.productInEdit.DiscountDollars) >= Number(this.state.productInEdit.PriceDollars)) {
						this.setState({
							discountMessage: 'Discounted price must be less than the original price.'
						});
					}

					if (!this.state.titleMessage && !this.state.discountMessage) {
						this.props.save({
							...model
						});
						this.props.cancel();
					}
                })
                .catch((response) => {
				    console.log(response);
                });
        }	
	}

	onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.productInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
            productInEdit: edited
        });

		if (name == "title") {
			this.setState({
				titleMessage: ''
			});
		} else if (name == 'DiscountDollars') {
			this.setState({
				discountMessage: ''
			});
        }
	};
 
	handleColor = (event) => {
        if (event.target.value.length > 0) {
            let temp = Object.assign({}, this.state);
            temp.productInEdit.colors = event.target.value.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
            temp.colorList = event.target.value.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
            this.setState({
                ...temp
            })
        } else {
            let temp = Object.assign({}, this.state);
            temp.productInEdit.colors = [];
            temp.colorList = [];
            this.setState({
                ...temp
            })

        }
	};

	handleSize = (event) => {
        if (event.target.value.length > 0) {
            let temp = Object.assign({}, this.state);
            temp.productInEdit.sizes = event.target.value.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
            temp.sizeList = event.target.value.sort((a, b) => (a.description > b.description) ? 1 : ((b.description > a.description) ? -1 : 0));
            this.setState({
                ...temp
            })
        } else {
            let temp = Object.assign({}, this.state);
            temp.productInEdit.sizes =[];
            temp.sizeList = [];
            this.setState({
                ...temp
            })
        }
	};

	handleProductTypeChange = (event) => {
        const edited = this.state.productInEdit;
        edited.productTypeId = event.target.value.id;
		edited.ProductType = event.target.value;

		this.setState({
            selectedProductType:event.target.value,
            productInEdit:edited
		})
    };
    handleFiles = (event) => {
        const edited = this.state.productInEdit;
        edited.ImageURL = event.base64;
		edited.Image = event?{
			name: event.fileList[0].name,
			source: event.base64,
			extension: event.fileList[0].type
        } : null;
        this.setState({
            productInEdit: edited
        });
	}

	handleNumericChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.productInEdit;
		edited[name] = value;
		this.setState({
			productInEdit: edited
		});
	}

	render() {
		return (
		<div className="eventDialog">
            <Dialog onClose={this.props.cancel}>
                    {!this.state.productInEdit.ProductId ?
                        <h2 className="adjust-dist-title2">Add New Product</h2> :
                        <h2 className="adjust-dist-title2">Edit Product</h2>}    
				<form className="user-form productsForm" onSubmit={this.handleSubmit}>
						<div className="col-md-6 user-form-left">
								<div className="form-group col-md-6 col-lg-5">
									<label htmlFor="IsPublished" className="callout-small">Visible to customers?</label>
									<Switch
										filter="boolean"
										onChange={this.onDialogInputChange}
										onLabel={'Yes'}
										offLabel={'No'}
										checked={this.state.productInEdit.IsPublished}
										value={this.state.productInEdit.IsPublished || ''}
										name="IsPublished"
										id="IsPublished"
									/>
								</div>
								<div className="form-group col-md-6 col-lg-4">
									<label htmlFor="isMemberOnly" className="callout-small">Members Only?</label>
									<Switch
										filter="boolean"
										onChange={this.onDialogInputChange}
										onLabel={'Yes'}
										offLabel={'No'}
										checked={this.state.productInEdit.IsMemberOnly}
										value={this.state.productInEdit.IsMemberOnly || ''}
										name="IsMemberOnly"
										id="IsMemberOnly"
									/>
								</div>
								<div className="form-group col-md-6 col-lg-3">
									<label htmlFor="isAddOn" className="callout-small">Add On?</label>
									<Switch
										filter="boolean"
										onChange={this.onDialogInputChange}
										onLabel={'Yes'}
										offLabel={'No'}
										checked={this.state.productInEdit.IsAddOn}
										value={this.state.productInEdit.IsAddOn || ''}
										name="IsAddOn"
										id="IsAddOn"
									/>
								</div>
								<div className="form-group col-md-12">
									<label className="callout">PRODUCT DETAILS</label>
                                </div>

								<div className="form-group col-md-7 col-lg-7">
									<label htmlFor="title">Title</label>
									<Input
										required={true}
										type="text"
										name="Title"
										id="Title"
										value={this.state.productInEdit.Title || ''}
										onChange={this.onDialogInputChange}
									/>
                                <p className="error-message">{this.state.titleMessage}</p>
								</div>
								<div className="form-group col-md-6 col-lg-6">
									<label htmlFor="productType">Product Type</label>
									<DropDownList 
										required={true} 
										data={this.props.common.productTypes}
										onChange={this.handleProductTypeChange}
										value={this.state.productInEdit.ProductType}
										textField="name"
										dataItemKey="id"
										allowCustom={true}
										name="productType"
										id="productType"
									/>
								</div>
								<div className="form-group col-md-12 col-lg-12">
									<label htmlFor="Description">Description</label>
									<textarea
										required={true}
										type="text"
										name="Description"
										id="Description"
										className="k-textarea"
										value={this.state.productInEdit.Description || ''}
										onChange={this.onDialogInputChange}
									></textarea>
								</div>
								<div className="form-group col-md-12">
									<label className="callout">PRICING</label>
                                </div>
                                <div className="form-group col-md-6 col-lg-6">
								    <label htmlFor="PriceDollars">Price</label>
								    <div className="price">
									    <span className="prefix sign">$</span>
									    <Input
										    type="number"
										    required={true}
										    step="0.01"
										    min="0"
										    name="PriceDollars"
										    id="PriceDollars"
										    value={this.state.productInEdit.PriceDollars || ''}
										    onChange={this.handleNumericChange}
									    />
								    </div>
                                </div>
                                <div className="form-group col-md-6 col-lg-6">
                                    <label htmlFor="DiscountDollars">Discounted Price</label>
                                    <div className="price">
									{this.state.productInEdit.DiscountDollars? <span className="prefix sign">$</span>: ""}
                                        <Input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            name="DiscountDollars"
                                            id="DiscountDollars"
											value={
												this.state.productInEdit.DiscountDollars != null ?
													this.state.productInEdit.DiscountDollars
													:
													''
											}
                                            onChange={this.onDialogInputChange}
											placeholder="No Discount"
                                        />
									</div>
									<p className="error-message">{this.state.discountMessage}</p>
                                </div>
							</div>
							<div className="col-md-6 user-form-right">
								<div className="col-sm-12 v-spacer"></div>
								<div className="form-group col-md-12">
									<label className="callout">PRODUCT VARIANTS</label>
								</div>
								<div className="form-group col-md-12 col-lg-12">
                                <label htmlFor="color">Color</label>
                                    <MultiSelect
                                        data={this.props.common.allColors}
                                        onChange={this.handleColor}
										value={this.state.productInEdit.colors}
                                        textField="description"
                                        dataItemKey="colorOptionId"
                                        allowCustom={true}
                                        id="color"
                                        name="color"
                                        className="multiSelection"
                                    /> 
								</div>
                            <div className="row">                           
                            </div>
                            <div className="form-group col-md-12 col-lg-12">
                                <label htmlFor="size">Size</label>
                                <MultiSelect
                                    data={this.props.common.allSizes}
                                    onChange={this.handleSize}
									value={this.state.productInEdit.sizes}
                                    textField="description"
                                    dataItemKey="sizeOptionId"
                                    allowCustom={true}
                                    id="size"
                                    name="size"
                                    className="multiSelection"
                                />
								</div>
								<div className="container">
									<div className="form-group col-md-6">
										<label className="callout">PRODUCT IMAGE</label>
										<p className="callout-info">Tip: Best images are Square format. 250 X 250 pixels or more</p>
									</div>

									<div className="form-group col-md-6 productUploads">
										<div className="v-spacer"></div>
										<ReactFileReader fileTypes={[".jpg",".jpeg",".png"]} base64={true} multipleFiles={false} handleFiles={this.handleFiles} >
											<div className='btnPrimary'>
												<i className="fas fa-file-upload"></i>
												<span>Upload File</span>
											</div>
										</ReactFileReader>
									</div>
									<div className="col-md-12 productUploads">
                                        {
                                            this.state.productInEdit.ImageURL ?
                                                <img alt="" src={this.state.productInEdit.ImageURL} />
                                            : ""
                                        }
									</div>
								</div>
							</div>
							<DialogActionsBar>
								<div className="adjust-btns">
									<div className="form-group">
										<button className="admin-k-button" onClick={this.props.cancel}>
											<i className="fas fa-times"></i>
											<span>CANCEL</span>
										</button>
										{!this.state.productInEdit.ProductId ? (
											<button type = "submit" className="admin-k-button">
												<i className="fas fa-save"></i>
												<span>SAVE</span>
											</button>
										) : (
											<button type = "submit" className="admin-k-button">
												<i className="fas fa-edit"></i>
												<span>UPDATE</span>
											</button>
										)}
									</div>
								</div>
							</DialogActionsBar>
				</form>
			</Dialog>
		</div>
		);
	}
 }
// export default EventForm;
 function mapStateToProps(state) {
	return {
		common: state.common
	};
}

export default connect(mapStateToProps, { getColors, getSizes, getProductTypes})(ProductForm);
